export default __webpack_public_path__ + "static/media/V470MANH1.480a3d5e.pdf";